var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportsG = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3366 0H1.66338C0.745385 0 0 0.748125 0 1.6695V19.3279C0 20.2519 0.745385 21 1.66338 21H15.3366C16.2546 21 17 20.2519 17 19.3279V1.6695C17 0.748125 16.2546 0 15.3366 0ZM3.27185 4.33125H8.49739C9.00215 4.33125 9.41277 4.74075 9.41277 5.25C9.41277 5.75925 9.00215 6.16875 8.49739 6.16875H3.27185C2.76708 6.16875 2.35646 5.75662 2.35646 5.25C2.35646 4.74337 2.76708 4.33125 3.27185 4.33125ZM13.6 15.0937H3.4C2.89523 15.0937 2.48462 14.6816 2.48462 14.175C2.48462 13.6684 2.89523 13.2562 3.4 13.2562H13.6C14.1048 13.2562 14.5154 13.6657 14.5154 14.175C14.5154 14.6842 14.1048 15.0937 13.6 15.0937ZM13.6 10.6312H3.4C2.89523 10.6312 2.48462 10.2191 2.48462 9.7125C2.48462 9.20587 2.89523 8.79375 3.4 8.79375H13.6C14.1048 8.79375 14.5154 9.20325 14.5154 9.7125C14.5154 10.2217 14.1048 10.6312 13.6 10.6312Z",
    fill: "#8E949B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportsG);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reports-g.1e06cb1a3dd00d47f25d270d0098b002.svg";